<template>
  <error-boundary :error-key="['travelLineRestartIntegration', 'travelLineIntegration']">
    <e-loader v-if="interactionId && !integration" class="text-blue mt-10 mx-auto" :size="60" :width="4" />

    <template v-else>
      <hotel-data-form v-if="activeStep === 1" />
      <t-l-side-settings v-else-if="activeStep === 2" />
      <c-m-settings v-else-if="activeStep === 3" ref="CMSettingsRef" />
      <room-categories v-else-if="activeStep === 4" />
      <service-groups v-else-if="activeStep === 5" :is-edit="isEdit" />
      <tourists-types v-else-if="activeStep === 6" />
      <placing-variants v-else-if="activeStep === 7" />

      <div class="mb-10" />

      <div class="d-flex justify-space-between mt-auto mt-md-0">
        <e-btn
          v-if="(!isEdit && activeStep > 0) || (isEdit && activeStep > 4)"
          prepend-icon-src="arrowLeft"
          variant="secondary"
          @click="back"
        >
          Назад
        </e-btn>

        <v-spacer />

        <div :id="travelLineIntegrationSubmitButtonTeleport" />
      </div>

      <t-l-side-error-dialog @close="close" />
    </template>
  </error-boundary>
</template>

<script setup lang="ts">
import { toRef } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { EBtn, ELoader } from '@/core/components/ui';
import { useFetch } from '@/core/composables/useFetch';
import { travelLineIntegrationSubmitButtonTeleport } from '@/core/consts/teleport';
import { RouteNames } from '@/core/plugins/router/routeNames';
import ErrorBoundary from '@/parts/errors/components/ErrorBoundary.vue';
import { useAccommodationObjectsStore } from '@/parts/objects/store/accommodationObjects';
import CMSettings from '@/parts/tariffs/components/CM/TravelLine/CMSettings.vue';
import HotelDataForm from '@/parts/tariffs/components/CM/TravelLine/HotelDataForm.vue';
import PlacingVariants from '@/parts/tariffs/components/CM/TravelLine/PlacingVariants.vue';
import RoomCategories from '@/parts/tariffs/components/CM/TravelLine/RoomCategories.vue';
import ServiceGroups from '@/parts/tariffs/components/CM/TravelLine/ServiceGroups.vue';
import TLSideErrorDialog from '@/parts/tariffs/components/CM/TravelLine/TLSideErrorDialog.vue';
import TLSideSettings from '@/parts/tariffs/components/CM/TravelLine/TLSideSettings.vue';
import TouristsTypes from '@/parts/tariffs/components/CM/TravelLine/TouristsTypes.vue';
import { useTravelLineStore } from '@/parts/tariffs/store/travelLine';

const $route = useRoute();
const $router = useRouter();

const props = defineProps<{
  isEdit?: boolean;
}>();

const { getTravelLineIntegration, activeStep, setActiveStep, checkActiveStep, integration } = useTravelLineStore(
  props.isEdit,
);

const { getActiveObject } = useAccommodationObjectsStore();

const interactionId = toRef(() => $route.query.interactionId);

useFetch(async () => {
  await getActiveObject();

  await getTravelLineIntegration();
  checkActiveStep();
});

const back = () => {
  if (activeStep.value === 0) {
    $router.push({
      name: RouteNames.CMList,
    });
  }

  setActiveStep(activeStep.value - 1, true);
};

const close = () => {
  $router.push({ name: RouteNames.CMList });
};
</script>

<style scoped lang="scss"></style>
